import './Header.css';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import React from 'react';
import Logout from '../account/Logout';
import LangSwitcher from './LangSwitcher';

const Header = () => {
	const { t } = useTranslation();
    const user = useSelector(state => state.auth.user);
	const navigate = useNavigate();

	return (
	    <div className='Header'>
			<div className='Header-logo' onClick={() => navigate('/cabinet')}/>
			<div className='Header-text'>
			{user ?
				<React.Fragment>
					{user.role === 'root' && <big>{t('header.root')}</big>}
					{user.role === 'admin' && <big>{t('header.admin')}</big>}
					{user.role === 'agent' && <big>{t('header.agent')}</big>}
					{user.role === 'exhibitor' && <big>{t('header.exhibitor')}</big>}
					<small>
						<span onClick={() => navigate('/cabinet/userview/' + user._id)}>{user.email}</span>
						<Logout/>
					</small>
				</React.Fragment>
				: <big>{t('header.unknown')}</big>
			}
			</div>
			<div className='Header-menu'>
				<LangSwitcher/>
			</div>
        </div>
	);
};

export default Header;
